import React, { useEffect} from 'react';
import './Header.scss';
import { mykBranding, support } from '../../../assets/images';
import { ModalPopup, OutlineButton, PrimaryButton } from '../../CommonComponent';
import searchicon from '../../../assets/images/Search.svg'
import { operations as headeroperations, selectors as headerSelector } from "../../../state/features/header";
import { useDispatch, useSelector } from 'react-redux';
import machineservice from "../../../services/machineservice";
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../const/resource";
import helperfunctions from "../../../utils/helperfunctions";
import { Error } from "@progress/kendo-react-labels";
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

const Header = (props: any) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { guestUserUrlLink } = props;
    const imgUrl = props?.imgURL;
    const dispatch = useDispatch();
    const [showVerification, setShowVerification] = React.useState<boolean>(false);
    const [zipCode, setZipCode] = React.useState<any>("");
    const [orderId, setOrderId] = React.useState<any>("");
    const dispatchCartCount = headeroperations.dispatchCartCount(dispatch);
    const [zipRequired, setZipRequired] = React.useState<any>(false);
    const { cartCount }: any = useSelector((state) => ({
        cartCount: headerSelector.cartCount(state)
    }));

    const login = () => {
        helperfunctions.ClearLocalStorage();
        window.location.href = "/auth/GuestLogout";
        return null;
    };
    const [showWarnigPopup, setShowWarnigPopup] = React.useState<boolean>(false);

    useEffect(() => {
        machineservice.getCartCount().then((response: any) => {
            dispatchCartCount({ result: response });
        }).catch((error: any) => {
        });
    }, [])

    const redirectToMvc = () => {
        window.location.href = `${guestUserUrlLink?.myKomastuBaseUrl}?fromParts=true`;
    }

    const onRegister = () => {
        window.location.href = guestUserUrlLink?.mvcRegisterUrl;
    }

    const hideVerificationPopup = () => {
        setShowVerification(false);
        setZipCode("");
        setZipRequired(false);
    }

    const onVerification = () => {
        if (zipCode?.length > 0 && orderId?.length > 0) {
            setZipRequired(false);
            setShowVerification(false);
            window.location.href = `${guestUserUrlLink?.mvcGuestUserPartStoreUrl}?orderId=${orderId}&zipcode=${zipCode}`;
        }
        if (zipCode?.length == 0) {
            setZipRequired(true);
        }
    }

    const onEnter = (e: any) => {
        if (e.code == "Enter") {
            onSearch();
        }
    }

    const onSearch = () => {
        if (orderId?.length > 0) {
            setShowVerification(true);
        }
        else {
            setShowWarnigPopup(true);
        }
    }

    const hideWarnigPopup = () => {
        setShowWarnigPopup(false);
    }

    return (
        <>
        <ToastContainer theme="colored" />
        <div className="container-fluid header-wrapper">
            <div className="page-logo">
                <a>
                    <div className="leftList">
                        <img src={imgUrl + mykBranding} alt="logo" className="logoImg" />
                    </div>
                </a>
            </div>
            <div className='page-top'>
                <div className='headerright_wrapper'>
                        <span className='search-input-icon'>
                            <input type="text" id="search" className="search" placeholder="Enter Order # to track" onKeyDown={onEnter} onChange={(e: any) => { setOrderId(e.target.value) }} />
                            <img className="search_icon" alt="search_icon" src={searchicon} onClick={onSearch} onKeyDown={() => { } } />
                    </span>
                    <ul className='inlineList'>
                        <li className='mr-1'>
                            <a href='#' title='Customer Support' className='mt-0' onClick={redirectToMvc}>
                                <img src={imgUrl + support} alt='Support' />
                            </a>
                        </li>
                            <li className='mr-1'>
                                {(cartCount?.result > 0) && <em className="notificationCount">{cartCount.result}</em>}
                                <a href="#" title='Cart' className='mt-0' onClick={() => { localStorage.setItem("isShoppingCartRefresh", "true"); navigate("/GuestUserShoppingCart"); }}>
                                    <em className="icon-cart"></em>
                            </a>
                        </li>
                        <li>
                                <PrimaryButton text={'Login'} className='ml-2 mr-2' title='Login' onClick={login} />
                        </li>
                        <li title='Register Now'>
                            <OutlineButton text={'Register Now'} onClick={onRegister} />
                        </li>
                    </ul>
                </div>
            </div>
        </div>

            {
                showVerification && (
                    <ModalPopup
                        ModalPopupName={"verification"}
                        ModalPopupTitle="Verification"
                        ModalPopupType="small"
                        closeModalPopup={hideVerificationPopup}
                        ShowModalPopupFooter={true}
                        PrimaryBtnOnclick={onVerification}
                        SecondryBtnOnclick={hideVerificationPopup}
                        FooterPrimaryBtnTxt={t(RESOURCE.MyK_Label_OK)}
                        FooterSecondaryBtnTxt={t(RESOURCE.MyK_Label_Cancel)}>
                        <div className='row mb-3'>
                            <div className='col-8 mb-1'>
                                <label>Enter the zipcode:</label>
                            </div>
                            <div className="col-12 col-md-12 col-lg-9 col-xl-8">
                                <input type='text' value={zipCode || ""}
                                    onChange={(e: any) => setZipCode(e.target.value)}
                                    className='textbox' />
                                {zipRequired && zipCode?.length == 0 && <Error>{String(t(RESOURCE.MyK_Label_Required))}</Error>}
                            </div>
                        </div>
                        </ModalPopup>
                )}

            {
                showWarnigPopup && (
                    <ModalPopup
                        ModalPopupName={"message"}
                        ModalPopupTitle="Message"
                        ModalPopupType="medium"
                        closeModalPopup={hideWarnigPopup}
                        ShowModalPopupFooter={true}
                        PrimaryBtnOnclick={hideWarnigPopup}
                        FooterPrimaryBtnTxt={t(RESOURCE.MyK_Label_OK)}>
                        <div className='row mb-3'>
                            <p>MYK-ORD-V109 : Please provide order number.</p>
                        </div>
                    </ModalPopup>
                )}
        </>
    );
};

export default Header;